/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Vendor-agnostic projection of one KYC vendor response step. Derived on read from the stored raw
 * response; never persisted. Lives in its own zero-import file so both the plugin layer and the admin
 * read path can import it without a module cycle.
 * @export
 */
export const VendorOutcomeCategory = {
    _11184809: '11184809',
    decision: 'decision',
    sanctions: 'sanctions',
    watchlist: 'watchlist',
    pep: 'pep',
    adverse_media: 'adverse_media',
    source: 'source',
    unknown: 'unknown',
    unknown_default_open_api: '11184809'
} as const;
export type VendorOutcomeCategory = typeof VendorOutcomeCategory[keyof typeof VendorOutcomeCategory];


export function instanceOfVendorOutcomeCategory(value: any): boolean {
    for (const key in VendorOutcomeCategory) {
        if (Object.prototype.hasOwnProperty.call(VendorOutcomeCategory, key)) {
            if (VendorOutcomeCategory[key as keyof typeof VendorOutcomeCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function VendorOutcomeCategoryFromJSON(json: any): VendorOutcomeCategory {
    return VendorOutcomeCategoryFromJSONTyped(json, false);
}

export function VendorOutcomeCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): VendorOutcomeCategory {
    return json as VendorOutcomeCategory;
}

export function VendorOutcomeCategoryToJSON(value?: VendorOutcomeCategory | null): any {
    return value as any;
}

